<template>
  <div class="px-6">
    <AppDataProperty
      contentId="pubs"
      @dataAvailable="
        data => {
          pubsGot(data?.metaData?.pubs)
        }
      "
    />
    <AppDataProperty
      contentId="couponsPubs"
      @dataAvailable="
        data => {
          pubsGot(data?.metaData?.pubs, true)
        }
      "
    />
    <div
      :class="{
        'h-[24vh]': !sallPubs,
        'h-[20vh]': sallPubs,
        disableClippedBg: !displayCouponsPubs,
      }"
      class="relative dropShadowLg"
    >
      <!-- <div
        class="absolute w-full h-full pubsContainerCliped"
        style="backdrop-filter: blur(3px);"
      ></div>
      <div
        class="absolute w-full h-full gradient-border pubsBorder pointer-events-none"
      ></div>
      <div
        class=" h-full overflow-hidden pubMainContainer opacity-90  relative rounded-content-md "
      > -->
      <div class="w-full h-full">
        <swiper-container
          ref="swiper"
          :slides-per-view="'1'"
          space-between="10"
          centered-slides="false"
          autoplay-delay="6000"
          init="false"
          autoplay-disable-on-interaction="false"
        >
          <swiper-slide v-for="(pub, i) in pubsToDisplay" :key="i">
            <div class="relative">
              <div
                :class="{
                  'h-[26vh]': !sallPubs,
                  'h-[20vh]': sallPubs,
                }"
                class="relative"
              >
                <div
                  class="absolute w-full h-full pubsContainerCliped"
                  style="backdrop-filter: blur(8px)"
                ></div>
                <div
                  class="absolute w-full h-full opacity-40 rounded-content-md"
                >
                  <div
                    class="absolute w-full h-full pubsContainerCliped pubContainerBg"
                  ></div>
                </div>
                <div
                  class="absolute w-full h-full gradient-border pubsBorder !opacity-30 pointer-events-none"
                ></div>
                <div class="absolute w-full h-full rounded-content-md">
                  <div
                    class="h-full overflow-hidden pubMainContainer opacity-100 relative"
                  >
                    <div class="w-full h-full pubsContainerCliped">
                      <div
                        class="w-full h-full flex items-center justify-center relaive"
                        :class="{
                          shimmerElementRoundedDefault: pub.shimmer,
                        }"
                      >
                        <img
                          :src="pub.pictureUrl"
                          alt=""
                          class="w-full h-full object-cover absolute"
                        />
                        <div class="w-full h-full absolute [backdrop-filter:blur(5px)]"></div>
                        <img
                          :src="pub.pictureUrl"
                          alt=""
                          class="w-full h-full object-contain relative"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <button
                class="buttonComponent small absolute"
                :class="{
                  'bottom-2 right-3': !displayCouponsPubs,
                  'bottom-2 right-4': displayCouponsPubs,
                }"
                @click="launchPubAction(pub)"
                v-if="pub.isCouponPub"
              >
                {{ $t('publicities.couponPubButton') }}
              </button>
            </div>
          </swiper-slide>
        </swiper-container>
      </div>
      <!-- </div> -->
      <!-- {{ pubs }} -->
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import AppDataProperty from './AppDataProperty.vue'

export default defineComponent({
  name: 'Publicities',
  components: { AppDataProperty },
  props: {
    displayCouponsPubs: {
      type: Boolean,
      default: false,
    },
    sallPubs: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pubs: [{ shimmer: true }, { shimmer: true }],
      couponsPubs: [{ shimmer: true }, { shimmer: true }],
      eventsIds: [],
    }
  },
  mounted() {
    this.initSlider()
  },
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
  },
  methods: {
    initSlider() {
      const swiper = this.$refs.swiper
      const params = {
        injectStyles: [
          `
        .swiper-pagination {
          margin-top:10px;
          position:relative;
          width: max-content!important;
          --swiper-pagination-bullet-width: 3px;
          --swiper-pagination-bullet-height: 3px;
          --swiper-pagination-bullet-inactive-opacity: 1;
          --swiper-pagination-bullet-inactive-color: red;
        }
      `,
          `
        .swiper-pagination-bullet {
          border: solid #5F7594 2px;
          background-color:transparent;
        }
      `,
          `
        .swiper-pagination-bullet-active {
          background-color: #5F7594
        }
      `,
        ],
      }

      Object.assign(swiper, params)

      swiper.initialize()
    },
    updateSlider() {
      this.$refs.swiper?.swiper?.update()
    },
    pubsGot(pubs, isCouponsPubs) {
      if (!pubs || !pubs[0]) return
      if (!isCouponsPubs && this.pubs[0].shimmer) this.pubs = pubs
      else if (isCouponsPubs && this.couponsPubs[0].shimmer)
        this.couponsPubs = pubs
      else return
      this.updateSlider()
      setTimeout(this.updateSlider, 100)
      setTimeout(this.updateSlider, 200)
      setTimeout(this.updateSlider, 500)
      setTimeout(this.updateSlider, 1000)
    },
    launchPubAction(pub) {
      if (/^http/i.test(pub.action)) {
        this.$Events.dispatchEvent('url_opening_required', {
          title: $t('publicities.clickToSeeMore'),
          subTitle: ' ',
          url: pub.action,
        })
        return
      }
      if (pub.isCouponPub) return this.copyPromoCode()
    },
    copyPromoCode() {
      this.$Commons.copy('LCAX', this.$t('publicities.propoCodeCopied'))
    },
    launchDeposit() {
      this.$Events.dispatchEvent('deposit_action_requested')
    },
  },
  computed: {
    pubsToDisplay() {
      if (this.displayCouponsPubs)
        return this.couponsPubs.map(pub => ({ ...pub, isCouponPub: true }))
      else
        return [
          ...this.pubs,
          ...this.couponsPubs.map(pub => ({ ...pub, isCouponPub: true })),
        ]
    },
  },
})
</script>

<style scoped>
.pubsContainerCliped {
  clip-path: polygon(0% 0%, 100% 0%, 100% 85%, 0% 100%);
}
.disableClippedBg .pubsContainerCliped {
  clip-path: none;
}
/* .pubContainerBg {
  background: #242c3b
    linear-gradient(
      169.98deg,
      rgba(131, 108, 143, 0.47) 27.98%,
      rgba(120, 48, 166, 0.47) 81.2%
    );
} */

.pubContainerBg {
  /**
  78859d
  242c3b
  d4d8df
   */
  background: #242c3b
    linear-gradient(
      169.98deg,
      rgba(131, 108, 143, 0.47) 27.98%,
      rgba(120, 48, 166, 0.47) 81.2%
    );
}
.pubsBorder:before {
  clip-path: polygon(
    0% 0%,
    0% 100%,
    var(--borderWidth) 100%,
    var(--borderWidth) var(--borderWidth),
    var(--innerTransparent) var(--borderWidth),
    var(--innerTransparent) calc(85% - var(--borderWidth)),
    var(--borderWidth) var(--innerTransparent),
    0 100%,
    100% 85%,
    100% 0%
  ) !important;
}
</style>
